import React from "react";
import ValuePropIntro from "../ValuePropIntro";

export default function EmbedVideo(props) {
    const {
        vpConfig: config,
        vpImage,
    } = props

    return (
        <div className="row">
            <ValuePropIntro {...props}/>
            <section>
                <video
                    style={{width: '100%'}}
                    className="video-player"
                    controls={config?.controls}
                    autoPlay={config?.autoPlay}
                    loop={config?.loop}
                    muted={config?.muted}
                    playsInline
                >
                    <source src={vpImage?.url} type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
            </section>
        </div>
    );
}
